<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead"><span><a id="auto_bookmark_table_of_contents_1"></a>Dedication</span></p>
<p class="P_WFP_BodyText">For our grandchildren and great-grandchildren—may you share our love for the beauty and majesty of the ocean, and for the fascinating creatures inhabiting those waters.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0004.vue?fa8651a6